// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Czin","unreadBadge":"styles_unreadBadge__fzVO2","modalContent":"styles_modalContent__Em3q-","modal":"styles_modal__3DDVc"};